import { SSEOptions } from "sse.js";
import { EventSourceOptions } from "./sse-client.interface";

const requiredHeaders = {
  'Accept': 'text/event-stream',
};

function setMethod(options: Partial<EventSourceOptions>): string {
  if (options.payload) {
    return 'POST';
  }

  return options.method || 'GET';
}

export function toSSEOptions(options: Partial<EventSourceOptions>): SSEOptions {
  return {
    headers: Object.assign(
      options.headers || {},
      requiredHeaders
    ),
    payload: options.payload || undefined,
    withCredentials: options.withCredentials != undefined ? options.withCredentials : true,
    method: setMethod(options),
    start: false
  };
}
